export class CloudEnvironmentHealthCheck {
    environmentId?: string;
    serviceName?: string;
}
